import {ReactElement, ReactNode} from 'react';
import {TFunction} from 'i18next';
import VideoUploader from './VideoUploader';
import WebcamRecorder from './WebcamRecorder';

type Props = {
  title: string | ReactNode;
  onStartRecording: (stopRecording: () => void) => void;
  onVideoReady: (video: Blob) => void;
  onProcessingVideo?: () => void;
  onClearVideo: () => void;
  enableAudioSource: boolean;
  rightColumnInitialComponent?: ReactNode | null;
  mask?: ReactNode;
  t: TFunction;
};

function WebcamRecorderWithFallback({
  title,
  onStartRecording,
  onVideoReady,
  onProcessingVideo,
  onClearVideo,
  enableAudioSource,
  rightColumnInitialComponent,
  mask,
  t
}: Props): ReactElement {
  if (typeof MediaRecorder === 'undefined') {
    return (
      <VideoUploader
        rightColumnInitialComponent={rightColumnInitialComponent}
        onVideoReady={onVideoReady}
        onClearVideo={onClearVideo}
        t={t}
      />
    );
  }
  return (
    <WebcamRecorder
      title={title}
      onStartRecording={onStartRecording}
      onVideoReady={onVideoReady}
      onProcessingVideo={onProcessingVideo}
      onClearVideo={onClearVideo}
      enableAudioSource={enableAudioSource}
      rightColumnInitialComponent={rightColumnInitialComponent}
      mask={mask}
      t={t}
    />
  );
}

export default WebcamRecorderWithFallback;
